module.exports = __webpack_public_path__ + "img/Accountor-24-lowres.2a08cb98.jpg";